import { useEffect } from 'react';
export default function useKey(callback) {
  var eventTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['keydown'];
  var node = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  useEffect(function () {
    eventTypes.forEach(function (eventType) {
      return node.addEventListener(eventType, callback);
    });
    return function () {
      eventTypes.forEach(function (eventType) {
        return node.removeEventListener(eventType, callback);
      });
    };
  }, [callback]);
}